import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CustomBtn from "components/fragments/CustomBtn";
import { useDispatch } from "react-redux";
import { authHandler } from "../../redux/handlers";


export default function ChangeEmployeeModal({
  modalPinOpenObj,
  modalOpenObj,
  selectedUserIdObj,
  modalSuccessOpenObj,
  ...props
}) {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [error, setError] = useState("");

  // ใช้วิธีการจัดการ form แบบ manual แทนการใช้ formik
  // เพื่อแก้ปัญหาการทำงานกับ MUI Modal
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors((prev) => ({
      ...prev,
      email: e.target.value ? "" : "อีเมลหรือเบอร์โทรศัพท์ is required",
    }));
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrors((prev) => ({
      ...prev,
      password: e.target.value ? "" : "รหัสผ่าน is required",
    }));
  };

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  const validate = () => {
    const newErrors = {};
    if (!email) newErrors.email = "อีเมลหรือเบอร์โทรศัพท์ is required";
    if (!password) newErrors.password = "รหัสผ่าน is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setIsLoading(true);
      setError("");

      const branchPosId = localStorage.getItem("branchPOSId");

      const response = await dispatch(
        authHandler.changeEmployee(businessSlug, {
          email: email,
          password: password,
          branchPosId: branchPosId,
        })
      );

      if (response) {
        localStorage.setItem("email", response.user.email);

        if (response.access_token) {
          localStorage.setItem("accessToken", response.access_token);
        }
        if (response.refresh_token) {
          localStorage.setItem("refreshToken", response.refresh_token);
        }

        await dispatch(authHandler.getUserBusinessProfile(businessSlug));

        resetForm();
        modalOpenObj.setModalOpen(false);
        modalSuccessOpenObj.setModalOpen(true);
      }
    } catch (err) {
      console.error("Error changing employee:", err);
      setError("เกิดข้อผิดพลาดในการเปลี่ยนพนักงาน กรุณาลองใหม่อีกครั้ง");
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setEmail("");
    setPassword("");
    setErrors({});
    setTouched({});
    setError("");
  };

  const handleClose = () => {
    resetForm();
    modalOpenObj.setModalOpen(false);
  };

  useEffect(() => {
    if (modalOpenObj.modalOpen) {
      resetForm();
    }
  }, [modalOpenObj.modalOpen]);

  return (
    <div>
      <Modal
        aria-labelledby="change-employee-modal"
        aria-describedby="change-employee-form"
        open={modalOpenObj.modalOpen}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        disableEnforceFocus // แก้ปัญหา focus ใน Modal
        keepMounted // คงสถานะ DOM เพื่อแก้ปัญหา event handlers
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white w-[min(38.67vw,396px)] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-18 text-[var(--color-black-2)] text-center leading-[1.8] font-[700] z-50">
            {" "}
            {/* เพิ่ม z-index ให้สูงขึ้น */}
            <div className="text-24 font-[700] flex flex-col items-center mb-5 pb-2">
              <div className="w-[min(4.83vw,49.5px)] aspect-square">
                <img
                  className="w-full h-full object-contain"
                  src="/img/logo-3.png"
                  alt=""
                />
              </div>
              <div className="comfortaa">
                <span className="text-[--color-grey]">Allder</span>{" "}
                <span className="text-[--color-green]">Cafe'</span>
              </div>
            </div>
            {error && <div className="text-red-500 text-16 mb-4">{error}</div>}
            <form onSubmit={handleSubmit} className="w-full">
              {/* Email input */}
              <div className="custom-input sarabun text-18 mt-[min(1.95vw,20px)] w-full">
                <input
                  className={`w-full rounded-[min(0.78vw,8px)] border-[1px] border-[#b6bbc6] py-[min(1.66vw,17px)] px-[min(1.95vw,20px)] pr-[min(4.2vw,42px)] ${
                    touched.email && errors.email ? "error" : ""
                  }`}
                  placeholder="อีเมลหรือเบอร์โทรศัพท์"
                  name="email"
                  value={email}
                  onChange={handleEmailChange}
                  onBlur={() => handleBlur("email")}
                  disabled={isLoading}
                />
              </div>
              {touched.email && errors.email && (
                <div className="text-red-500 text-12 text-left mt-1">
                  {errors.email}
                </div>
              )}

              {/* Password input */}
              <div className="custom-input-password custom-input sarabun text-18 relative mt-[min(1.95vw,20px)] w-full">
                <input
                  className={`w-full rounded-[min(0.78vw,8px)] border-[1px] border-[#b6bbc6] py-[min(1.66vw,17px)] px-[min(1.95vw,20px)] pr-[min(4.2vw,42px)] ${
                    touched.password && errors.password ? "error" : ""
                  }`}
                  type="password"
                  placeholder="รหัสผ่าน"
                  name="password"
                  value={password}
                  onChange={handlePasswordChange}
                  onBlur={() => handleBlur("password")}
                  disabled={isLoading}
                />
              </div>
              {touched.password && errors.password && (
                <div className="text-red-500 text-12 text-left mt-1">
                  {errors.password}
                </div>
              )}

              <div className="py-3"></div>
              <div className="flex justify-center gap-[min(2.01vw,20.63px)] mt-[min(0.98vw,30px)] mb-3">
                <CustomBtn
                  onClick={handleClose}
                  className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-[#6D788D] font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-second-2-active`}
                  btntxt={"ยกเลิก"}
                  disabled={isLoading}
                />
                <CustomBtn
                  type="submit"
                  className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-white font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-main-active`}
                  btntxt={isLoading ? "กำลังดำเนินการ..." : "ยืนยัน"}
                  disabled={isLoading}
                />
              </div>
            </form>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
